export const ProjectDetailsModalOptionsTranslations = {
  en: {
    projectDetailsOptions: {
      edit: "Edit",
      delete: "Delete",
    },
  },
  es: {
    projectDetailsOptions: {
      edit: "Editar",
      delete: "Eliminar",
    },
  },
};
